import { render, staticRenderFns } from "./OrderDetail-new.vue?vue&type=template&id=e086b318&scoped=true&"
import script from "./OrderDetail-new.vue?vue&type=script&lang=js&"
export * from "./OrderDetail-new.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetail-new.vue?vue&type=style&index=0&id=e086b318&prod&lang=css&"
import style1 from "./OrderDetail-new.vue?vue&type=style&index=1&id=e086b318&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e086b318",
  null
  
)

export default component.exports